// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  COMMON_UNSET_NOTIFICATION,
} from './constants';

export function unsetNotification() {
  return {
    type: COMMON_UNSET_NOTIFICATION,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COMMON_UNSET_NOTIFICATION:
      return {
        ...state,
        notification: state.notification.clear()
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/common/redux/unsetNotification.js